import { render, staticRenderFns } from "./AppointmentButtons.vue?vue&type=template&id=2f73400f&scoped=true"
import script from "./AppointmentButtons.vue?vue&type=script&lang=js"
export * from "./AppointmentButtons.vue?vue&type=script&lang=js"
import style0 from "./AppointmentButtons.vue?vue&type=style&index=0&id=2f73400f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.35_babel-core@7.0.0-bridge.0_@babel+core@7.29._80ed213f6ba743306e514f7b7b6c1c5b/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f73400f",
  null
  
)

export default component.exports